import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import AboutFour from '../container/About/AboutFour';
import Video from '../container/Video/Video';
import AboutFive from '../container/About/AboutFive';
import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import data1 from '../data/content/aboutFourContent';
import data2 from '../data/content/aboutFiveContent';
import CallToActionThree from "../container/CallToAction/CallToActionThree";
import {useLocation} from "react-router-dom";
import data3 from "../data/SEO/seoData";

const CyberSecurity = () => {
    const currentPage = useLocation();
    let seo_data = data3.filter(dataObj => dataObj.path === currentPage.pathname);
    return (
        <React.Fragment>
            <SEO title={seo_data[0].metaTitle} URL={seo_data[0].path} description={seo_data[0].metaDesc} />
            <Header />
            <Breadcrumb
                image={seo_data[0].bcEleImage}
                title={seo_data[0].bcEleTitle}
                content="Home"
                contentTwo="CyberSecurity"
            />
            <AboutFour
                mainContent={data1.cyberSecurity.mainContent}
                subTitle={data1.cyberSecurity.subTitle}
                title={data1.cyberSecurity.title}
                backgroundImg={data1.cyberSecurity.backgroundImg} foregroundImg={data1.cyberSecurity.foregroundImg}
            />
            <Video content="Strengthening the Cyber Posture" />
            <AboutFive
                mainContent={data2.cyberSecurity.mainContent}
                subTitle={data2.cyberSecurity.subTitle}
                title={data2.cyberSecurity.title}
                backgroundImg={data2.cyberSecurity.backgroundImg} foregroundImg={data2.cyberSecurity.foregroundImg}
            />
            {/*<TestimonialContainer classOption="bg-primary-blue" />*/}
            <CallToActionThree titleContent="Ready to Secure Your Digital Future?" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default CyberSecurity;



